import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { cancelAccount } from '../../../store/actions/data-user.actions';
import { AppState } from '../../../store/app-reducers';
import { CancelAccountState } from '../../../store/reducers/data-user.reducer';
import { GTMEventsCrash } from '../../enums/Crashlytics';
import { CrashlyticsService } from '../../services/crashlytics/crashlytics.service';
import { ToastControllerService } from '../../services/toast-controller.service';

@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './confirm-cancel.page.html',
  styleUrls: ['./confirm-cancel.page.scss'],
})
export class ConfirmCancelPage implements OnInit, OnDestroy {

  public loading = false;

  private errorCancel = '';
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private modalCtrl: ModalController
    , private store: Store<AppState>
    , private translate: TranslateService
    , private toastS: ToastControllerService
    , private crashlytics: CrashlyticsService
  ) { }

  async ngOnInit() {
    this.store.select('cancelAccount')
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackCancelAccount);

    this.errorCancel = this.translate.instant('CatCodes.error_cancel_account');
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  private callbackCancelAccount = async (resp: CancelAccountState) => {
    this.loading = resp.loading;
    if (resp.success) {
      this.modalCtrl.dismiss(true);
    }
    if (resp.failed) {
      this.toastS.presentToast(this.errorCancel, 'grayDemon', 'alert', 2500, 'toast-network');
      await this.crashlytics.sendCrashPlatform(GTMEventsCrash.cancelAccountApi, resp.error);
    }
  }

  public onClose = (accept: boolean) => {
    if (accept) {
      this.store.dispatch(cancelAccount());
      return;
    }
    this.modalCtrl.dismiss(accept);
  }

}
